import { getRequest, postRequest, patchRequest, deleteRequest } from './util/requestAlias';
import { buildURL, buildRequestBody } from './util/requestHandler';
/**
 * 🔑删除回答
 *
 * 只要没有错误异常，无论是否有回答被删除，该接口都会返回成功。  管理员可删除回答。回答作者是否可删除回答，由管理员在后台的设置决定。
 */

export const del = params => deleteRequest(buildURL('/answers/{answer_id}', params));
/**
 * 🔑为回答投票
 *
 * 为回答投票。
 */

export const addVote = params => postRequest(buildURL('/answers/{answer_id}/voters', params), buildRequestBody(params, ['type']));
/**
 * 在指定回答下发表评论
 *
 * 在指定回答下发表评论。
 */

export const createComment = params => postRequest(buildURL('/answers/{answer_id}/comments', params, ['include']), buildRequestBody(params, ['content']));
/**
 * 🔐批量删除回答
 *
 * 批量删除回答。  只要没有错误异常，无论是否有回答被删除，该接口都会返回成功。
 */

export const deleteMultiple = params => deleteRequest(buildURL('/answers/{answer_ids}', params));
/**
 * 🔑取消为回答的投票
 *
 * 取消为回答的投票。
 */

export const deleteVote = params => deleteRequest(buildURL('/answers/{answer_id}/voters', params));
/**
 * 获取回答详情
 *
 * 获取回答详情。
 */

export const get = params => getRequest(buildURL('/answers/{answer_id}', params, ['include']));
/**
 * 获取指定回答的评论
 *
 * 获取指定回答的评论。
 */

export const getComments = params => getRequest(buildURL('/answers/{answer_id}/comments', params, ['page', 'per_page', 'order', 'include']));
/**
 * 🔐获取回答列表
 *
 * 获取回答列表。
 */

export const getList = (params = {}) => getRequest(buildURL('/answers', params, ['page', 'per_page', 'order', 'include', 'answer_id', 'question_id', 'user_id', 'trashed']));
/**
 * 获取回答的投票者
 *
 * 获取回答的投票者。
 */

export const getVoters = params => getRequest(buildURL('/answers/{answer_id}/voters', params, ['page', 'per_page', 'include', 'type']));
/**
 * 🔐把回答放入回收站
 *
 * 把回答放入回收站。
 */

export const trash = params => postRequest(buildURL('/answers/{answer_id}/trash', params, ['include']));
/**
 * 🔐批量把回答放入回收站
 *
 * 批量把回答放入回收站。
 */

export const trashMultiple = params => postRequest(buildURL('/answers/{answer_ids}/trash', params, ['include']));
/**
 * 🔐把回答移出回收站
 *
 * 把回答移出回收站。
 */

export const untrash = params => postRequest(buildURL('/answers/{answer_id}/untrash', params, ['include']));
/**
 * 🔐批量把回答移出回收站
 *
 * 批量把回答移出回收站。
 */

export const untrashMultiple = params => postRequest(buildURL('/answers/{answer_ids}/untrash', params, ['include']));
/**
 * 🔑修改回答信息
 *
 * 管理员可修改回答。回答作者是否可修改回答，由管理员在后台的设置决定。  &#x60;content_markdown&#x60; 和 &#x60;content_rendered&#x60; 两个参数仅传入其中一个即可， 若两个参数都传入，则以 &#x60;content_markdown&#x60; 为准。
 */

export const update = params => patchRequest(buildURL('/answers/{answer_id}', params, ['include']), buildRequestBody(params, ['content_markdown', 'content_rendered']));